import { Avatar } from 'antd';
import Icon from 'assets/Icons';
import clsx from 'clsx';
import Box from 'components/Box';
import Text from 'components/Text';
import { ITurnManualAppointmentItem, ITurnManualItem } from 'features/turn/services/types/turn';
import { minBy } from 'lodash';
import moment from 'moment';
import { useMemo } from 'react';
import shopSelectors from 'services/shop/selectors';
import uiSelector from 'services/UI/selectors';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';

export type IStaffTurnItem = {
  staffId: string;
  staffAvatar: string;
  staffName: string;
  turns: ITurnManualItem[];
  totalTurn: number;
  turnAmount: number;
  totalInprogress: number;
  appointments: ITurnManualAppointmentItem[];
  indexClockIn: number;
  totalAmount: number;
};

type Props = {
  data: IStaffTurnItem;
  appointments: ITurnManualAppointmentItem[];
  onClickStaff: () => void;
  onVoiceCall?: () => void;
  voiceCallStaff?: boolean;
  simpleStaffTurn?: boolean;
};
const TurnStaffTopRow = ({ data, onClickStaff, onVoiceCall = () => undefined, voiceCallStaff, appointments = [], simpleStaffTurn = false }: Props) => {
  const allSetting = shopSelectors.data.allSetting();

  const currentTime = uiSelector.getCurrentTime();
  const timeAppointment = useMemo(() => {
    return minBy(appointments.map(o => {
      return ({
        time: moment(o.startTime, 'hh:mm A').diff(moment(currentTime), 'minutes'),
        startTime: o.startTime,
        endTime: o.endTime,
      });
    }).filter(o => o.time >= 0), 'time');
  }, [appointments, currentTime]);
  if (simpleStaffTurn) {
    return (
      <NameColumn onClick={onClickStaff} type='button' className={clsx('TurnStaffTopRow', !!timeAppointment && 'timeAppointment', voiceCallStaff && 'voiceCallStaff', simpleStaffTurn && 'simpleStaffTurn')}>
        <Box display='flex' alignSelf='stretch' alignItems='center' pr={voiceCallStaff ? '2' : undefined}>
          <ImageContainer>
            <Avatar
              src={data.staffAvatar || 'fail'}
              size={timeAppointment ? 45 : 60}
            >{data.staffName?.charAt(0)}</Avatar>
          </ImageContainer>
          <Box display='flex' flexDirection='column' alignItems='start' gap='2' style={{ flex: 1 }}>
            <Text variant='CONTENT_2' className='text-overflow staff-name' style={{ textAlign: 'left', flex: 1, maxWidth: 80, minWidth: 80 }}>{data.staffName}</Text>
          </Box>
        </Box>
        {!!timeAppointment && <div className='time-container'>
          <span>{timeAppointment.startTime} - {timeAppointment.endTime}</span>
        </div>}
      </NameColumn>
    );
  }
  return (
    <NameColumn onClick={onClickStaff} type='button' className={clsx('TurnStaffTopRow', !!timeAppointment && 'timeAppointment', voiceCallStaff && 'voiceCallStaff')}>
      <Box display='flex' alignItems='center' pr={voiceCallStaff ? '2' : undefined}>
        <ImageContainer>
          <Avatar
            src={data.staffAvatar || 'fail'}
            size={timeAppointment ? 45 : 60}
          >{data.staffName?.charAt(0)}</Avatar>
          <div className='total-turn-box'><span>{data.turnAmount.toString()}</span></div>
        </ImageContainer>
        <Box display='flex' flexDirection='column' alignItems='start' gap='2'>
          <Text variant='CONTENT_2' className='text-overflow staff-name' style={{ textAlign: 'left', maxWidth: 80, minWidth: 80 }}>{data.staffName}</Text>
          {allSetting?.displayAmountTurn && (
            <Text variant='BODY_2' style={{ color: 'blue' }}>{formatCurrency(data.totalAmount)}</Text>
          )}
        </Box>
        {!!voiceCallStaff && <button onClick={e => [e.stopPropagation(), onVoiceCall()]} className='btn-call-staff' ><Icon type='callStaff' /></button>}
      </Box>
      {!!timeAppointment && <div className='time-container'>
        <span>{timeAppointment.startTime} - {timeAppointment.endTime}</span>
      </div>}
    </NameColumn>
  );
};

export default TurnStaffTopRow;
const NameColumn = styled.button`
    min-width: 165px;
    max-width: 165px;
    display: flex;
    align-items: center;
    flex-direction: column;
   
    .circle-avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  .time-container {
    margin-top: 3px;
    background: #eed202;
    display: flex;
    flex-direction: column;
    padding: 3px 4px;
    border-radius: 4px;
    border: 1.5px solid #1D2129;
    span {
     font-size: 15px;
     font-weight: 700;
     color: #1D2129;
    }
  }

  &.voiceCallStaff {
    min-width: 240px;
    max-width: 240px;
  }

   &.simpleStaffTurn {
    min-width: 180px;
    max-width: 180px;
  }
`;
const ImageContainer = styled.div`
    min-width: 40px;
    padding: 0 10px;
    position: relative;
    span {
        width: 40px;
        height: 40px;
        line-height: 38px;
    }

    .total-turn-box {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #000;
      display: flex;
      width: 30px;
      height: 30px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 100px;
      background: #0DA472;
      span {
        color: #FFF;
        text-align: center;
        font-family: Poppins;
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 30px; /* 166.667% */
        text-transform: capitalize;
      }
    }
`;
